import { create } from 'zustand';
const useVideoPropertiesServiceOutput = create(() => ({}));
const reactiveOutput = {
    useVideoProperties: () => {
        return useVideoPropertiesServiceOutput((state) => state.videoProperties);
    },
};
export class VideoPropertiesServiceOutput {
    static getReactiveOutput() {
        return reactiveOutput;
    }
    setVideoProperties(videoProperties) {
        useVideoPropertiesServiceOutput.setState({ videoProperties });
    }
}
